import { makeVar } from '@apollo/client';

// Reactive variable to track channel online statuses
// Moved from deleted OnlineStatus component - still used by logging utilities
export const channelOnlineStatusesVar = makeVar<Record<string, boolean>>({});
